<script setup lang="ts"></script>

<template>
  <div class="row">
    <div
      class="alert alert-danger bg-danger alert-dismissible text-light fs-5"
      role="alert"
    >
      <strong>{{ $t("err007") }}</strong>
    </div>
  </div>
</template>

<style scoped></style>
